export const actionTypes = {
    NEW_BRANCH: "NEW_BRANCH",
    LOADER: "LOADER",
    BRANCH_LIST: "BRANCH_LIST",
    ALL_BRANCH_LIST: "ALL_BRANCH_LIST",
    ALL_MEMBER_LIST: "ALL_MEMBER_LIST",
    ADMIN_LIST : "ADMIN_LIST",
    ALL_MASTER_MEMBER_LIST: "ALL_MASTER_MEMBER_LIST",
    ALL_MASTER_DATA: "ALL_MASTER_DATA",
    ALL_BRANCH_LIST_ADMIN : "ALL_BRANCH_LIST_ADMIN",
    ALL_FAMILY_MEMBER_LIST : "ALL_FAMILY_MEMBER_LIST",
    ALL_FAMILY_CORPORATE_LIST : 'ALL_FAMILY_CORPORATE_LIST',
    ALL_VFS_UK_DATA : 'ALL_VFS_UK_DATA'
};

const INITIAL_STATE = {
    NewBranch: [],
    corporateloader: false,
    BranchList: [],
    AllBranchList: [],
    MemberList: [],
    AdminList: [],
    AllMasterMemberList: [],
    AllMasterData: [],
    AllBranchListAdmin: [],
    AllFamilyMemberList : [],
    AllFamilyCorporateList : [],
    AllVfsUkData : []
};

const MasterAdminReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.LOADER:
            return {
                ...state,
                corporateloader: action.corporateloader,
            };

        case actionTypes.NEW_BRANCH:
            return {
                ...state,
                NewBranch: action.NewBranch,
                corporateloader: action.corporateloader,
            };
        case actionTypes.BRANCH_LIST:
            return {
                ...state,
                BranchList: action.BranchList,
            };
        case actionTypes.ALL_BRANCH_LIST:
            return {
                ...state,
                AllBranchList: action.AllBranchList,
            };
        case actionTypes.ALL_MEMBER_LIST:
            return {
                ...state,
                MemberList: action.MemberList,
            };
        case actionTypes.ADMIN_LIST:
            return {
                ...state,
                AdminList: action.AdminList,
            };
        case actionTypes.ALL_MASTER_MEMBER_LIST:
            return {
                ...state,
                AllMasterMemberList: action.AllMasterMemberList,
            };
        case actionTypes.ALL_MASTER_DATA:
            return {
                ...state,
                AllMasterData: action.AllMasterData,
            };
        case actionTypes.ALL_BRANCH_LIST_ADMIN:
            return {
                ...state,
                AllBranchListAdmin: action.AllBranchListAdmin,
            };
        case actionTypes.ALL_FAMILY_MEMBER_LIST:
            return {
                ...state,
                AllFamilyMemberList: action.AllFamilyMemberList,
            };
        case actionTypes.ALL_FAMILY_CORPORATE_LIST:
            return {
                ...state,
                AllFamilyCorporateList: action.AllFamilyCorporateList,
            };
        case actionTypes.ALL_VFS_UK_DATA:
              return {
                ...state,
                AllVfsUkData: action.AllVfsUkData,
            };

        default:
            return state;
    }
};

export default MasterAdminReducer;
